import type { $Keys } from 'utility-types'

export const tagInfoProps = {
  workplace: 'workplace',
  start_day: 'start_day',
  legal_gender: 'legal_gender',
  legal_entity: 'legal_entity',
}

export type TagInfoProp = $Keys<typeof tagInfoProps>
